import { takeEvery } from 'redux-saga/effects';

import { qcsSyncGetResource, qcsSyncUpdateResource }
  from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';
import * as actions from './actions';
import {makeProfileFull} from './types';

const mkResourceConfig = (props) => mkQcsSyncResourceConfig({
  resourceName: 'User Profiles',
  resourceBaseUrl: '/userprofiles',
  axiosConfig: { headers: { 'qcs-dataset-id': null } },
  getLastSyncDate: () => undefined,
  transformResourceToRequestData: (resource) => resource.toJS ? resource.toJS() : resource,
  transformResponseToResource: (response: any) => makeProfileFull(response.data),
  ...props,
});


export function* getProfileActionWatcher(): Generator<*, *, *> {
  const config = mkResourceConfig({
    resourceBaseUrl: '/userprofiles/me',
    successAction: actions.getProfileSuccess,
    failureAction: actions.getProfileFailure,
  });
  yield takeEvery(actions.getProfile, qcsSyncGetResource, config);
}

export function* updateProfileActionWatcher(): Generator<*, *, *> {
  const config = mkResourceConfig({
    successAction: actions.updateProfileSuccess,
    failureAction: actions.getProfileFailure,
  });
  yield takeEvery(actions.updateProfile, qcsSyncUpdateResource, config);
}

// for loading watcher sagas
export default [
  getProfileActionWatcher,
  updateProfileActionWatcher,
];
